/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]{display:block;padding:30px}h1[_ngcontent-%COMP%]{margin:0 0 10px;font-weight:300}.genre-name[_ngcontent-%COMP%]{text-transform:capitalize}loading-indicator[_ngcontent-%COMP%]{margin:30px 0}"];
export { styles as styles };
